import { TableInstance } from 'react-table';
import React, { useRef } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@mui/material';

import styles from '@lmt/unicorn-shared/app/components/patients/list/components/PatientsTable.module.scss';

// eslint-disable-next-line @typescript-eslint/ban-types
export function AppTable<D extends object = object>(props: {
  table: TableInstance<D>;
}) {
  const tableObj = props.table;
  const tableRef = useRef<HTMLDivElement>(null);
  return (
    <TableContainer
      ref={tableRef}
      className={styles.tableContainer}
      component={Paper}
      data-test-id="app-table"
    >
      <Table
        stickyHeader
        aria-label="sticky table"
        {...(tableObj.getTableProps() as any)}
        className={styles.table}
      >
        <TableHead>
          {tableObj.headerGroups.map((headerGroup, index) => (
            <TableRow
              {...(headerGroup.getHeaderGroupProps() as any)}
              key={index}
            >
              {headerGroup.headers.map((column, index) => (
                <TableCell
                  {...(column.getHeaderProps(
                    column.getSortByToggleProps(),
                  ) as any)}
                  key={index}
                  className={
                    column.canSort ? styles.sortableHeader : styles.header
                  }
                >
                  <TableSortLabel
                    active={column.isSorted}
                    direction={
                      column.isSorted
                        ? column.isSortedDesc
                          ? 'desc'
                          : 'asc'
                        : undefined
                    }
                    disabled={!column.canSort}
                    style={{ userSelect: 'none' }}
                  >
                    {column.render('Header')}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableHead>
        <TableBody {...(tableObj.getTableBodyProps() as any)}>
          {tableObj.rows.map((row) => {
            tableObj.prepareRow(row);
            return (
              <TableRow {...(row.getRowProps() as any)} key={row.id} hover>
                {row.cells.map((cell, index) => {
                  return (
                    <TableCell
                      {...(cell.getCellProps({
                        style: {
                          minWidth: cell.column.minWidth,
                          width: cell.column.width,
                        },
                      }) as any)}
                      key={index}
                      className={styles.tableCell}
                    >
                      {cell.render('Cell')}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
